/**
 * The client's SPA wiring (ADR-013 §4), same rules as apps/web: no class names or inline
 * styles, DTO → props mappers, relative imports inside this package. This stub adds no routes.
 */
import type { ExtRoute } from '@slims-pro/ext-api';

/** Mounted at `/x/<path>`, each behind its `x.` feature key. */
export const extraRoutes: ExtRoute[] = [];
